import { useNavigate } from "react-router-dom";
import { GatewayInfoSocieteOrias } from "@conformite/gateway";
import { ConformiteSocieteList } from "./ConformiteSocieteList";

export function ConformiteSocieteListGarantieFinanciereIas() {
  const navigate = useNavigate();

  return (
    <ConformiteSocieteList
      getFormAvancement={(entreprise) =>
        entreprise.avancement.garantieFinanciereIas ?? 0
      }
      defaultFilters={{
        categories: GatewayInfoSocieteOrias.CategorieIASList,
      }}
      title="Garantie financière IAS"
      onSocieteRedirect={(entreprise) => {
        navigate(`${entreprise.siren}?fromAxe`);
      }}
    />
  );
}
